import { Injectable, Inject, LOCALE_ID } from '@angular/core';
// import * as Sentry from '@sentry/browser';

export enum LogType {
  FATAL = 'fatal',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  DEBUG = 'debug'
}

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(@Inject(LOCALE_ID) public locale: string) {
    this.setLocale();
  }

  log(message: any, type = LogType.ERROR) {
    try {
      // Sentry.captureException(new Error(JSON.stringify(message)));
    } catch (error) {}
  }

  setUser(email: string) {
    try {
      // Sentry.configureScope((scope) => {
      //   scope.setUser({email});
      // });
    } catch (error) {}
  }

  setLocale() {
    try {
      // Sentry.configureScope((scope) => {
      //   scope.setTag('locale', this.locale);
      // });
    } catch (error) {}
  }
}
